export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/array.js
// module id = 692
// module chunks = 0